<script lang="ts" setup>
import type {
  Coordinate,
  FlightAutoCompleteSuggestion,
} from '@libs/trip-planner-interfaces';
import { AppIconButton } from '@libs/ui';

import {
  AutoCompleteType,
  AutoCompleteHeader,
  AutoCompleteSuggestionsList,
} from '../autoComplete';

interface AirportSelectorProps {
  initialAirport?: string;
  initialUserPosition?: Coordinate;
  showBackButton?: boolean;
}
const props = defineProps<AirportSelectorProps>();

interface AirportSelectorEmits {
  (
    eventName: 'airportSelected',
    airportSuggestion: FlightAutoCompleteSuggestion
  ): void;
  (eventName: 'goBack'): void;
}
const emit = defineEmits<AirportSelectorEmits>();
</script>

<template>
  <div class="airport-selector">
    <div class="airport-selector-header">
      <AppIconButton
        v-if="props.showBackButton"
        type="secondary"
        state="enabled"
        size="large"
        :icon="{ name: 'arrowLeft' }"
        :ariaLabel="$t('a11y.back_to_previous_step')"
        @click="emit('goBack')"
      />
      <AutoCompleteHeader
        :auto-complete-type="AutoCompleteType.Airport"
        :initial-search-text="props.initialAirport"
        :auto-focus="true"
        :search-position="props.initialUserPosition"
        class="airport-search"
      />
    </div>
    <div class="airport-suggestions">
      <AutoCompleteSuggestionsList
        @select-airport-suggestion="emit('airportSelected', $event)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.airport-selector {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .airport-selector-header {
    display: flex;
    align-items: center;
    gap: var(--spacing-16);

    .airport-search {
      flex: 1;
    }
  }
}

.airport-suggestions {
  margin-top: var(--spacing-24);
  overflow: auto;
}
</style>
